import Vue from 'vue';
import microEventMixin from 'common-module/src/mixins/microEventMixin';
import { merge } from 'lodash';

const eventBus = new Vue();
Vue.prototype.eventBus = eventBus;

Vue.config.optionMergeStrategies.microEvents = (parent, child) => {
  return merge({}, parent, child);
};
Vue.mixin(microEventMixin);
export default eventBus;
